import "@babel/polyfill";
import { initFormatsDropdown } from "@/modules/_old-modules/formats-dropdown";
import { initMobileFormatsSelect } from "@/modules/_old-modules/formats-native-dropdown";

const nativeDropdownWrapper = $(".js-formats-native-dropdown-wrapper");
const customDropdownWrapper = $(".formats-dropdown");

const changeStateSelector = $(".js-update-state");

const updateCustomDropdownValue = () => {
  customDropdownWrapper.find("input[type=radio]").each(function() {
    if ($(this).val() === nativeDropdownWrapper.find("select").val()) {
      $(this).attr("checked", "checked");

      if (changeStateSelector) {
        changeStateSelector.attr("href", $(this).val());
      }
    }
  });
};

const updateNativeDropdownValue = () => {
  const customDropdownValue = customDropdownWrapper.find("input:checked").val();

  nativeDropdownWrapper.find("select").val(customDropdownValue);

  if (changeStateSelector) {
    changeStateSelector.attr("href", customDropdownValue);
  }
};

$(document).ready(function() {
  initMobileFormatsSelect(updateCustomDropdownValue);
  initFormatsDropdown(updateNativeDropdownValue);
});
